import { useMutation } from "@apollo/client";

import { GqlCourseCreateInput } from "~/__generated__";

import { CourseCreateRoute_CreateDocument } from "../mutations.generated";

export default function useCourseCreateRoute_Create() {
    const [createCourse, { data, loading, error }] = useMutation(CourseCreateRoute_CreateDocument);

    const create = (input: GqlCourseCreateInput) =>
        createCourse({
            variables: {
                input,
            },
        });

    return {
        createCourse: create,
        loading,
        error,
        data: data?.courseCreate,
    };
}
